export default "__VITE_ASSET__DAn7NFPh__"